export const getUrlFromEventTitle = (title) => title.toLowerCase().replaceAll(" ", "-");

export const getUrlFromOrgName = (title) => title.toLowerCase().replaceAll(" ", "-");
